<ng-container *hasPermission="['PARKING_AREA_READ','PARKING_AREA_ALL']">
  <div class="container-fluid">
    <div class="page-title">
      <h2>Elenco Parcheggi</h2>
    </div>
    <app-filter-panel [criteria]="searchCriteria">
      <ng-template #fields>
        <form [formGroup]="searchForm" (ngSubmit)="search()">
          <div class="row">
            <div class="mb-4">
              <label for="name" class="form-label">Name</label>
              <input type="text" class="form-control ss-no-validation" id="name" name="name" formControlName="name" />
            </div>
          </div>

          <div class="d-flex justify-content-end  align-items-center col-12 m-2 gap-2">
            <button type="button" class="btn  btn-outline-secondary" (click)="clearFilter()">Cancella</button>
            <button type="submit" class="btn btn-primary"  >Cerca</button>
          </div>
        </form>
      </ng-template>
    </app-filter-panel>
    <div class="section-container">
      <div class="table-responsive">
        <table class="table caption-top table-hover table-striped">
          <caption>
            <button type="button" class="btn btn-primary" (click)="edit(0)"
              *hasPermission="['PARKING_AREA_CREATE','PARKING_AREA_ALL']"><i bTooltip title="Aggiungi"
                class="fa-solid fa-plus"></i></button>
            Risultati trovati: {{totalItems}}
          </caption>
          <thead>
            <tr>
              <th scope="col" class="row-button-sm"></th>
              <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'code'" [colValue]="'Code'"
                [baseSearchCriteria]="searchCriteria" (orderingClick)="ordering($event)"></th>
              <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'name'" [colValue]="'Nome'"
                [baseSearchCriteria]="searchCriteria" (orderingClick)="ordering($event)"></th>
              <th scope="col" class="row-button-sm">Abilitato</th>
              <th scope="col" class="row-button-sm">Mappa</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let parkingArea of parkingAreaList | paginate: {
                                      itemsPerPage: searchCriteria.pageSize,
                                      currentPage: searchCriteria.pageNumber,
                                      totalItems: totalItems } ">
              <td>
                <div class="d-flex justify-content-center  align-items-center gap-2">
                  <div class="cursor-pointer" (click)="edit(parkingArea.id!)"
                    *hasPermission="['PARKING_AREA_READ','PARKING_AREA_ALL']">
                    <i bTooltip title="Visualizza" class="fa-solid fa-pen"></i>
                  </div>
                  <div class="cursor-pointer" (click)="clone(parkingArea.id!)"
                    *hasPermission="['PARKING_AREA_CREATE','PARKING_AREA_ALL']">
                    <i bTooltip title="Clona" class="fa-solid fa-copy"></i>
                  </div>

                </div>
              </td>
              <td>{{parkingArea.code}}</td>
              <td>{{parkingArea.name}}</td>
              <td>
                <div class="form-check form-switch">
                  <input class="form-check-input cursor-pointer" type="checkbox" role="switch"
                    [checked]="parkingArea.active" [id]="'deviceChecked-'+parkingArea.id"
                    (click)="confirmOperation(parkingArea, 'SWITCH-STATUS', $event)">
                  <label class="form-check-label" for="deviceChecked"></label>
                </div>
              </td>
              <td>
                <div class="cursor-pointer" (click)="showMap(parkingArea)">
                  <i bTooltip title="Visualizza mappa" class="fa fa-eye"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
        previousLabel="Precedente" nextLabel="Successiva" screenReaderPaginationLabel="Paginazione"
        screenReaderPageLabel="Pagina" screenReaderCurrentLabel="Vai alla pagina">
      </pagination-controls>
    </div>

  </div>
  <app-confirmation-alert-input [showConfirmationModal]="showMapModal" [showCancelButton]="false"
    [showSaveButton]="false" [showCloseButton]="true" [modalTitle]="'Mappa area: ' + (selectedParking?.name??'')"
    (modalCancel)="closeMap()">
    <ng-template #fields>
      <app-parking-map [geojson]="coordinatesJsonToDrawMap" [readonly]="true" *ngIf="selectedParking?.coordinatesJson">
      </app-parking-map>
    </ng-template>
    <div class="alert alert-warning text-center" *ngIf="!selectedParking?.coordinatesJson">
      Posizioni non impostate.
    </div>
  </app-confirmation-alert-input>


  <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
    (modalConfirm)="modalOperationExec()" (modalCancel)="cancelModalOperationExec()">
  </app-confirm-alert>
</ng-container>